<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchKeyword"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        @keypress.enter="searchResponse()"
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Response Details</div>
                    <v-spacer></v-spacer>
                    <div
                      class="headline"
                      v-if="editedItem.modification_number != 0"
                    >
                      Modify: {{ editedItem.modification_number }}
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Id
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.id }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Project Id
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.project_id }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Dasher Name
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.dasher_name }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Starting Time
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.started_at }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Completed Time
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.completed_at }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Total Response Time
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ totalResponseTime }} Sec
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Response Time Average
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ avgResTime }} Sec
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>

                <v-layout row>
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="indigo white--text">
                        <div class="headline">Question & Answer</div>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="editedItem.project_type_id == 2">
                          <b>Task Accepted Location</b>
                          <br />
                          <span>
                            <b>Latitude:</b>
                            {{ editedItem.latitude }}
                          </span>
                          <br />
                          <span>
                            <b>Longitude:</b>
                            {{ editedItem.longitude }}
                          </span>
                        </div>

                        <div v-for="(ques, i) in editedItem.questions" :key="i">
                          <div>
                            <v-checkbox
                              v-model="selectedItem.checkbox[i].data"
                              primary
                              hide-details
                            ></v-checkbox>
                          </div>
                          <div>
                            <span>{{ i + 1 }}.</span>
                            <span
                              v-if="
                                editedItem.project_language == 1 ||
                                editedItem.project_language == 3
                              "
                            >
                              <span class="font-weight-bold">
                                Question Title English:
                              </span>
                              &nbsp;&nbsp;&nbsp;{{ ques.question }}
                              <span
                                class="red--text headline"
                                v-if="ques.required_optional == 1"
                              >
                                *
                              </span>
                            </span>
                            <br />
                            <span
                              class="font-weight-bold"
                              v-if="
                                editedItem.project_language == 2 ||
                                editedItem.project_language == 3
                              "
                            >
                              &nbsp;&nbsp;&nbsp;
                              <span class="font-weight-bold">
                                Question Title Bangla:
                              </span>
                              &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }}
                              <br />
                              <span
                                class="red--text headline"
                                v-if="ques.required_optional == 1"
                              >
                                *
                              </span>
                            </span>
                            <br>
                            <span><b>Question Type:</b> {{ ques.ui_category }} </span>
                          </div>
                          <span class="font-weight-bold">Answer:</span>
                          <!-- for image type -->
                          <div v-if="ques.ui_category_id == 9">
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              <v-img
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                height="150"
                                width="200"
                                :src="
                                  indexData.res_image +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></v-img>
                              <div v-else>NULL</div>
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.res_image +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <!-- for audio type -->
                          <div v-else-if="ques.ui_category_id == 10">
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              <audio
                                width="200"
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                controls
                              >
                                <source
                                  :src="
                                    indexData.res_audio +
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ]
                                  "
                                  type="audio/mp3"
                                />
                                Your browser does not support HTML audio.
                              </audio>
                              <br />
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.res_audio +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <!-- for video type -->
                          <div v-else-if="ques.ui_category_id == 11">
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              <video
                                width="200"
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                controls
                              >
                                <source
                                  :src="
                                    indexData.res_video +
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ]
                                  "
                                  type="video/mp4"
                                />
                                Your browser does not support HTML video.
                              </video>
                              <br />
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.res_video +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <!-- for contactInfo type -->
                          <div v-else-if="ques.ui_category_id == 15">
                            <div
                              v-if="
                                editedItem[
                                  getQuestionVariable(ques.question_sequence)
                                ]
                              "
                            >
                              <ContactInfoResponse
                                :contactForm="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              />
                            </div>
                          </div>
                          <!-- for multiple choice image -->
                          <div v-else-if="ques.ui_category_id == 14">
                            <div>
                              {{
                                showResponseForImageName(
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ],
                                  ques
                                )
                              }}
                            </div>
                            <div>
                              <v-img
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                height="150"
                                width="200"
                                :src="
                                  indexData.mul_choice_image +
                                  showResponseForImage(
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ],
                                    ques
                                  )
                                "
                              ></v-img>
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.mul_choice_image +
                                  showResponseForImage(
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ],
                                    ques
                                  )
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <div
                            v-else-if="
                              ques.ui_category_id == 1 ||
                              ques.ui_category_id == 2 ||
                              ques.ui_category_id == 4
                            "
                          >
                            <div v-if="ques.multiple_answer == '1'">
                              <div
                                v-for="(item, index1) in showMultipleResponse(
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ],
                                  ques
                                )"
                                :key="index1"
                              >
                                <li>{{ item }}</li>
                              </div>
                            </div>
                            <div v-else>
                              {{
                                showResponse(
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ],
                                  ques
                                )
                              }}
                            </div>
                          </div>
                          <!-- for open ended type -->
                          <div v-else>
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              {{
                                editedItem[
                                  getQuestionVariable(ques.question_sequence)
                                ]
                              }}
                            </div>
                          </div>
                          <span v-if="editedItem.time_expense">
                            <b>Time expense:</b>
                            {{
                              showResponseTime(
                                editedItem.time_expense,
                                getQuestionVariable(ques.question_sequence)
                              )
                            }}
                          </span>
                          <!-- here is comment field for a single question -->
                          <div v-if="selectedItem.checkbox[i].data == true">
                            <v-text-field
                              label="Write your message"
                              v-model="selectedItem.checkbox[i].value"
                              box
                              required
                            ></v-text-field>
                          </div>
                          <br />
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-list-tile-title class="font-weight-bold text-sm-center">
                  Modification Time & Comment
                </v-list-tile-title>
                <v-layout row justify-space-around>
                  <v-flex xs12>
                    <v-card>
                      <v-card-text class="px-1">
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <div class="ml-2 font-weight-bold">
                            Setup Modification Time
                          </div>
                          <v-layout row>
                            <v-flex xs4 class="ml-2">
                              <v-text-field
                                v-model="selectedItem.days"
                                :rules="day"
                                label="Modification Ending(Days)"
                                type="number"
                                box
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 class="ml-2">
                              <v-text-field
                                v-model="selectedItem.hours"
                                :rules="hour"
                                label="Modification Ending(Hours)"
                                type="number"
                                box
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 class="ml-2">
                              <v-text-field
                                v-model="selectedItem.minutes"
                                :rules="minutes"
                                label="Modification Ending(Minutes)"
                                type="number"
                                box
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs12>
                              <v-text-field
                                v-model="selectedItem.comment"
                                :rules="commentRules"
                                label="Write your final comments"
                                box
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="success" @click="verifyItem(editedItem)">
                  Accept
                </v-btn>
                <v-btn color="red" @click="close">Cancel</v-btn>
                <v-btn color="primary" @click="editItem(editedItem)">
                  Modify
                </v-btn>
                <v-btn color="warning" @click="rejectItem(editedItem)">
                  Reject
                </v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="alertMsg">
      <v-alert
        v-if="error == 0 && statusCode == 200"
        :value="true"
        type="success"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 204"
        :value="true"
        type="info"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
        :value="true"
        type="warning"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 500"
        :value="true"
        type="error"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
    </div>
    <div v-if="isLoaded">
      <div v-if="indexData.totalTasks < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <v-data-table
        :headers="headers"
        :items="indexData.dataStatus2.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.totalTasks > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.project_id }}</td>
          <td>{{ props.item.modification_number }}</td>
          <td>{{ props.item.dasher_id }}</td>
          <td>{{ props.item.started_at }}</td>
          <td>{{ props.item.completed_at }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="verifyItem(props.item)"
                >
                  done
                </v-icon>
              </template>
              <span>verify</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="rejectItem(props.item)"
                >
                  close
                </v-icon>
              </template>
              <span>reject</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataStatus2.from }} -
          {{ indexData.dataStatus2.to }} of {{ indexData.dataStatus2.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.dataStatus2.current_page"
            :length="indexData.dataStatus2.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import MultipleResponseView from "./MultipleResponseView";
  import ContactInfoResponse from "./ContactInfoResponse";
  import { mapGetters } from "vuex";

  export default {
    components: {
      MultipleResponseView,
      ContactInfoResponse,
    },
    data: () => ({
      dialog: false,
      alertMsg: false,
      // apiUrl: 'change-status',
      routePath: "/pending",
      sl: 1,
      headers: [
        { text: "Task Id", align: "left", value: "id" },
        { text: "Project Id", align: "left", value: "project_id" },
        {
          text: "Modification Number",
          align: "left",
          value: "modification_number",
        },
        {
          text: "Task Submitted By",
          align: "left",
          sortable: false,
          value: "dasher_id",
        },
        { text: "Task starting time", value: "started_at" },
        { text: "Task Completed Time", value: "completed_at" },
        { text: "Actions", align: "center", value: "name", sortable: false },
      ],
      loading: false,
      search: "",
      searchKeyword: "",
      pagination: {
        rowsPerPage: 10,
      },
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      counter: 0,
      selectedItem: {
        project_id: "",
        dasher_id: "",
        task_id: "",
        comment: "",
        days: "",
        hours: "",
        minutes: "",
        checkbox: [],
      },
      editedItem: {
        time_expense: [],
        questions: [],
      },
      totalResponseTime: 0,
      avgResTime: 0,
      projectID: "",
      defaultItem: {},
      valid: true,
      commentRules: [
        (v) =>
          !!v ||
          "This field is required if you need to modify any question else skip this!",
      ],
      day: [(v) => !!v || "Minimum value is required 0"],
      hour: [(v) => !!v || "Minimum value is required 0"],
      minutes: [(v) => !!v || "Minimum value is required 1"],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.dataStatus2) {
          return true;
        } else {
          return false;
        }
      },
    },

    watch: {
      pagination() {
        this.paginationMethod();
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      let l = this.indexData.questions.data.length;
      this.checkedItem(l);
    },

    methods: {
      initialize() {
        let projectId = window.localStorage.getItem("projectId");
        this.projectID = projectId;
        this.$store.dispatch("changeTaskStatus", [
          "task-status",
          2,
          projectId,
          "",
          1,
          5,
        ]);
        this.alertMsg = true;
        setTimeout(() => {
          this.alertMsg = false;
        }, 300);
      },
      showResponseForImage(value, question_data) {
        // console.log(value);
        return question_data.imageOptions[parseInt(value) - 1].url;
      },
      showResponseTime(time_array, question_data) {
        var response_time = "";
        time_array.forEach((element) => {
          const arrayFailed = Object.entries(element).map((arr) => ({
            fieldName: arr[0],
            message: arr[1],
          }));
          if (arrayFailed[0].fieldName == question_data) {
            response_time = arrayFailed[0].message + " Sec";
          }
        });
        return response_time;
      },
      showResponseForImageName(value, question_data) {
        return question_data.imageOptions[parseInt(value) - 1].title;
      },
      getQuestionVariable(questionSequence) {
        return "var" + questionSequence;
      },
      showResponse(value, question_data) {
        if (value) {
          var valueInt = parseInt(value);
          var return_title = "";
          if (
            (question_data.ui_category_id == 1 ||
              question_data.ui_category_id == 2 ||
              question_data.ui_category_id == 4) &&
            this.editedItem.project_language == 1
          ) {
            return question_data.options[valueInt - 1].title;
          } else if (
            (question_data.ui_category_id == 1 ||
              question_data.ui_category_id == 2 ||
              question_data.ui_category_id == 4) &&
            this.editedItem.project_language == 2
          ) {
            return question_data.bangla_options[valueInt - 1].title;
          } else if (
            (question_data.ui_category_id == 1 ||
              question_data.ui_category_id == 2 ||
              question_data.ui_category_id == 4) &&
            this.editedItem.project_language == 3
          ) {
            return (
              question_data.options[valueInt - 1].title +
              "(" +
              question_data.bangla_options[valueInt - 1].title +
              ")"
            );
          }
          return return_title;
        } else {
          return "NULL";
        }
      },

      showMultipleResponse(value, question_data) {
        if (value) {
          var return_title = [];
          if (
            (question_data.ui_category_id == 1 ||
              question_data.ui_category_id == 2 ||
              question_data.ui_category_id == 4) &&
            this.editedItem.project_language == 1
          ) {
            value.split("|").forEach((element) => {
              return_title.push(
                question_data.options[parseInt(element) - 1].title
              );
            });
          } else if (
            (question_data.ui_category_id == 1 ||
              question_data.ui_category_id == 2 ||
              question_data.ui_category_id == 4) &&
            this.editedItem.project_language == 2
          ) {
            value.split("|").forEach((element) => {
              return_title.push(
                question_data.bangla_options[parseInt(element) - 1].title
              );
            });
          } else if (
            (question_data.ui_category_id == 1 ||
              question_data.ui_category_id == 2 ||
              question_data.ui_category_id == 4) &&
            this.editedItem.project_language == 3
          ) {
            value.split("|").forEach((element) => {
              return_title.push(
                question_data.options[parseInt(element) - 1].title +
                  "(" +
                  question_data.bangla_options[parseInt(element) - 1].title +
                  ")"
              );
            });
          }
          // console.log(return_title);
          return return_title;
        } else {
          return ["null"];
        }
      },
      searchResponse() {
        this.paginationMethod();
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      checkedItem(length) {
        for (let i = 0; i < length; i++) {
          this.selectedItem.checkbox.push({
            data: false,
            value: null,
          });
        }
      },

      checkItem(item) {
        // reset all comment data
        if (this.indexData.dataStatus2.data) {
          this.selectedItem.project_id = null;
          this.selectedItem.dasher_id = null;
          this.selectedItem.task_id = null;
          this.selectedItem.days = null;
          this.selectedItem.hours = null;
          this.selectedItem.minutes = null;
          this.selectedItem.comment = null;
          let l = this.indexData.questions.data.length;
          for (let index = 0; index < l; index++) {
            this.selectedItem.checkbox[index].data = false;
            this.selectedItem.checkbox[index].value = null;
          }

          this.editedIndex = this.indexData.dataStatus2.data.indexOf(item);
          this.editedItem = Object.assign([], item);
          if (item.duration_json) {
            this.editedItem.time_expense = JSON.parse(item.duration_json);
          } else {
            this.editedItem.time_expense = null;
          }
          this.editedItem.questions = this.indexData.questions.data;
          var num_of_res = this.editedItem.time_expense.length;
          var response_time = 0;
          this.editedItem.time_expense.forEach((element) => {
            const arrayFailed = Object.entries(element).map((arr) => ({
              fieldName: arr[0],
              value: arr[1],
            }));
            response_time = response_time + parseInt(arrayFailed[0].value);
          });
          this.totalResponseTime = response_time;
          this.avgResTime = Math.round(response_time / num_of_res);
          this.dialog = true;
        }
      },

      verifyItem(item) {
        var popUpMsg = confirm("Are you sure want to verify this application?");
        if (popUpMsg) {
          this.$store.dispatch("changePendingTaskStatus", [
            "accept",
            item.id,
            item.project_id,
          ]);
          item.task_status_id = 6;
        }
        this.close();
      },
      // set dynamic comment here
      editItem(item) {
        // console.log(this.selectedItem)
        if (this.$refs.form.validate()) {
          this.selectedItem.project_id = item.project_id;
          this.selectedItem.dasher_id = item.dasher_id;
          this.selectedItem.task_id = item.id;
          var count = 0;
          for (let i = 0; i < this.selectedItem.checkbox.length; i++) {
            if (this.selectedItem.checkbox[i].data == true) {
              this.selectedItem.checkbox[i].data =
                this.indexData.questions.data[i].id;
              count = count + 1;
            }
          }
          this.counter = count;
          if (this.counter == 0) {
            var popUpMsg = confirm(
              "Please check questions those want to modify!"
            );
            if (popUpMsg) {
              this.dialog = true;
            } else {
              this.close();
            }
          } else {
            // console.log(this.selectedItem)
            let popUpMsg = confirm(
              "Are you sure want to permit for modification?"
            );

            if (popUpMsg) {
              this.$store.dispatch("editedTask", ["modify", this.selectedItem]);
              item.task_status_id = 3;
            }
            this.close();
          }
        }
      },

      rejectItem(item) {
        // console.log(item.project_id);
        var popUpMsg = confirm(
          "Are you sure you want to reject this application?"
        );
        if (popUpMsg) {
          this.$store.dispatch("changePendingTaskStatus", [
            "reject",
            item.id,
            item.project_id,
          ]);
          item.task_status_id = 4;
        }
        this.close();
      },

      close() {
        this.dialog = false;
        this.totalResponseTime = 0;
        this.avgResTime = 0;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          this.counter = 0;
        }, 300);
      },

      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        this.close();
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        this.loading = true;
        let tableName = window.localStorage.getItem("projectId");
        if (this.indexData.dataStatus2) {
          if (this.searchKeyword) {
            this.$store.dispatch("changeTaskStatusWithSearch", [
              "task-status-search",
              2,
              tableName,
              this.searchKeyword,
              this.indexData.dataStatus2.current_page,
              this.pagination.rowsPerPage,
            ]);
            this.loading = this.indexData.dataStatus2.data ? false : true;
            this.alertMsg = true;
            setTimeout(() => {
              this.alertMsg = false;
            }, 300);
          } else {
            this.$store.dispatch("changeTaskStatus", [
              "task-status",
              2,
              tableName,
              "",
              this.indexData.dataStatus2.current_page,
              this.pagination.rowsPerPage,
            ]);
            this.loading = !this.indexData.error ? false : true;
            this.alertMsg = true;
            setTimeout(() => {
              this.alertMsg = false;
            }, 300);
          }
        }
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
